// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__bhV78","newExpiryDate":"styles_newExpiryDate__xW3I8","footer":"styles_footer__2X0Xg"};